import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import BaseModal from 'flow/components/ui-components/BaseModal';
import Button from 'flow/components/ui-components/Button';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { acceptCookies, rejectCookies, saveConsentCategories } from 'flow/actions/app-actions';
import { selectConsentCategories } from 'flow/selectors/app-selectors';
import { categoriesFromRedux } from 'flow/types/consent';
import TrackingConsentOverview from './TrackingConsentOverview';
import TrackingConsentCustomise from './TrackingConsentCustomise';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TrackingConsentModal = function TrackingConsentModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    onDismiss = _ref.onDismiss;
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  var dispatch = useAppDispatch();
  var consentCategories = useAppSelector(selectConsentCategories);
  var _useState = useState('overview'),
    _useState2 = _slicedToArray(_useState, 2),
    screen = _useState2[0],
    setScreen = _useState2[1];
  var _useState3 = useState(function () {
      return categoriesFromRedux(consentCategories);
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    categories = _useState4[0],
    setCategories = _useState4[1];
  useEffect(function () {
    if (open) {
      setCategories(categoriesFromRedux(consentCategories));
    }
  }, [open, consentCategories]);
  var handleAcceptAll = function handleAcceptAll() {
    dispatch(acceptCookies());
    onDismiss();
  };
  var handleRejectAll = function handleRejectAll() {
    dispatch(rejectCookies());
    onDismiss();
  };
  var handleCategoryChange = function handleCategoryChange(key, value) {
    return setCategories(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, key, value));
    });
  };
  var handleAcceptSelected = function handleAcceptSelected() {
    if (Object.values(categories).every(Boolean)) {
      dispatch(acceptCookies());
    } else if (Object.values(categories).every(function (v) {
      return !v;
    })) {
      dispatch(rejectCookies());
    } else {
      dispatch(saveConsentCategories(categories));
    }
    onDismiss();
  };
  var handleClose = function handleClose() {
    setScreen('overview');
    onClose();
  };
  var header = screen === 'overview' ? i18next.t('settings.general.tracking.title') : /*#__PURE__*/_jsxs("div", {
    className: "flex items-center gap-2",
    children: [/*#__PURE__*/_jsx(Button, {
      iconKey: "arrow_back",
      color: "icon",
      onClick: function onClick() {
        return setScreen('overview');
      },
      "aria-label": i18next.t('Tooltip.Nav.Title.Back'),
      className: "-ms-1"
    }), /*#__PURE__*/_jsx("span", {
      children: i18next.t('settings.general.tracking.customise')
    })]
  });
  return /*#__PURE__*/_jsx(BaseModal, {
    open: open,
    onClose: handleClose,
    disableActions: true,
    disablePadding: true,
    disableHeaderForcedLowerCase: true,
    header: header,
    className: "h-[620px] [&>header]:h-16 [&>header]:px-6 [&>header>button]:-me-1",
    children: screen === 'overview' ? /*#__PURE__*/_jsx(TrackingConsentOverview, {
      onAcceptAll: handleAcceptAll,
      onRejectAll: handleRejectAll,
      onCustomise: function onCustomise() {
        return setScreen('customise');
      }
    }) : /*#__PURE__*/_jsx(TrackingConsentCustomise, {
      categories: categories,
      onCategoryChange: handleCategoryChange,
      onAcceptSelected: handleAcceptSelected
    })
  });
};
export default TrackingConsentModal;